import { useCallback, useState } from "react";
import { Alert, FormCheck } from "react-bootstrap";
import { useDispatch, useStore } from "react-redux";
import { konditionenActions } from "../reducers/konditionen-reducer";
import "./KonditionenSwitch.css";

const KonditionenSwitch = (props) => {
  const { configStorage } = useStore().getState();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [isToggling, setIsToggling] = useState(false);

  const onChange = useCallback((e) => {
    const target = e.originTarget || e.target;
    if (!target || isToggling) return;
    setIsToggling(true);
    dispatch(konditionenActions.setMaKond(target.checked))
      .then(() => setError(null))
      .catch((err) => {
        console.error("m1", err);
        setError(new Error("m1: Ein Übertragungsfehler ist aufgetreten"));
      })
      .finally(() => {        
        setTimeout(() => setIsToggling(false), 2000);
      });
  }, [dispatch, isToggling]);

  if (configStorage.isKundenShop()) return null;
  return <>
    <FormCheck
      name="mitarbeiter"
      type="switch"
      label="Mitarbeiter(in)"
      className="d-flex align-items-center gap-1"
    >
      <FormCheck.Input
        id="mitarbeiter"
        name="mitarbeiter"
        onChange={onChange}
        checked={configStorage.isMitarbeiterKonditionen()}
        disabled={configStorage.isLoadingMaKond() || isToggling}
      />
      <FormCheck.Label className="fs-6" htmlFor="mitarbeiter">Mitarbeiter(in)</FormCheck.Label>
    </FormCheck>
    {error ? <Alert>{error.toString()}</Alert> : null}
  </>;

};

export default KonditionenSwitch;
